<template>
  <main v-if="hasError || accessDenied">
    <div class="container d-flex flex-column">
      <div class="error-detail text-center">
        <span class="error-icon">!</span>
        <p id="err-title" class="error-title">
          {{ hasError ? $t("errorCallback.title") : $t("accessDenied.title") }}
        </p>
        <p id="err-description" class="error-description">
          {{ hasError ? $t("errorCallback.description") : $t("accessDenied.description") }}
        </p>
        <p id="err-contact" class="error-contact">
          {{ hasError ? $t("errorCallback.contact") : $t("accessDenied.contact") }}
        </p>
        <router-link :to="{ path: currentPath }" v-if="hasError">
          <span class="volver-caret">
            <span class="caret-left" />
          </span>
          <span class="volver-error">{{ $t("errorCallback.tryAgain") }}</span>
        </router-link>
        <b-button variant="link" @click="logout" v-else>
          <span class="volver-caret">
            <span class="caret-left" />
          </span>
          <span class="volver-error">{{ $t("accessDenied.tryAgain") }}</span>
        </b-button>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  name: "callback_page",
  components: {},
})
export default class CallbackPage extends Vue {
  @Getter("getCurrentLocation") currentLocation!: string;
  @Action("logout") logout!: () => Promise<void>;
  hasError = false;
  accessDenied = false;

  get currentPath(): string {
    if (!this.currentLocation) {
      return "/";
    }
    const url = new URL(this.currentLocation);
    return `${url.pathname}${url.search}`;
  }

  mounted(): void {
    Vue.$auth
      .signinRedirectCallback()
      .then(() => {
        this.goToCurrentPath();
      })
      .catch(() => {
        if (this.$route.query.error === "access_denied") {
          this.accessDenied = true;
        } else {
          this.hasError = true;
        }
      });

    history.pushState({}, "", this.currentPath);
  }

  goToCurrentPath(): void {
    this.$router.push({
      path: this.currentPath,
    });
  }
}
</script>

<style lang="scss" scoped>
main {
  height: 70vh;
  width: 100vw;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.error-icon {
  font-size: 50px;
  font-weight: bold;
  color: #efeded;
  background: #212529;
  display: block;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  margin: auto;
}

.error-title {
  margin-top: 1em;
  font-size: 2em;
  font-weight: 400;
}

.error-description {
  font-size: 1.1em;
  font-weight: 400;
}

.error-contact {
  padding-bottom: 1em;
}

.volver-caret {
  background-color: #ffd200;
  border-radius: 3px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  color: #22262e;
  font-size: 16px;
  display: inline-flex;
  vertical-align: top;

  .caret-left {
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid;
    display: inline-block;
    height: 0;
    width: 0;
    margin: auto auto auto 5px;
  }
}

.volver-error {
  display: inline-block;
  color: #22262e;
  font-size: 1.1em;
  line-height: 1em;
  vertical-align: top;

  &:hover {
    text-decoration: underline;
  }
}
</style>
